import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { Element, Item } from '@outdoria/types';
import { fetcher } from '../utils';
import { ADMIN_ITEM_UPDATE, ADMIN_ITEMS_ALL, ITEM } from '../queryKeys';

type Data = {
  item: Omit<Item, 'item_id' | 'item_type_id'>;
  elements: Element['element_id'][];
};
export const useAdminUpdateItem = (item_id: string) => {
  const queryClient = useQueryClient();

  const mutationFn = async ({ item, elements }: Data): Promise<void> => {
    const response = await fetcher(`/v2/admin/items/${item_id}`, {
      method: 'PUT',
      body: JSON.stringify({ ...item, elements }),
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
    });

    if (response.status !== 204)
      throw new Error(
        (await response.json()).error ??
          'Could not update the item for some unforeseen reason!',
      );

    queryClient.invalidateQueries({ queryKey: ADMIN_ITEMS_ALL });
    queryClient.invalidateQueries({ queryKey: ITEM, exact: false });
  };

  const { mutate, error, status, isPending, isSuccess, isError } = useMutation({
    mutationKey: ADMIN_ITEM_UPDATE,
    mutationFn,
  });

  return { mutate, error, status, isPending, isSuccess, isError };
};
